export default __webpack_public_path__ + "static/media/provider-icon1.d97fe526.svg";